<ion-row
  class="transaction-row"
  [ngClass]="vm?.selected && !isReview ? 'is-selected' : ''"
>
  <ion-col
    *ngIf="selectable"
    [size]="columnSizes['transaction-row-checkbox']"
    class="checkbox"
    data-cy="transaction-row-checkbox"
    (click)="onTransactionRowClick()"
  >
    <span class="dot">
      <ion-icon name="checkmark-outline"></ion-icon>
    </span>
  </ion-col>
  <ion-col
    [size]="columnSizes['transaction-row-customer-information']"
    *ngIf="!isReview"
    class="customer-column"
    data-cy="transaction-row-customer-information"
  >
    <div class="customer-content">
      <p data-cy="transaction-row-customer-name">
        {{ vm?.customerName | titlecase }}
      </p>
      <p data-cy="transaction-row-customer-number">#{{ vm?.customerNumber }}</p>
    </div>
  </ion-col>
  <ion-col
    [size]="columnSizes['transaction-row-transaction-information']"
    [ngClass]="{ 'has-secondary': vm?.hasSecondaryTransaction }"
    class="invoice-column"
    data-cy="transaction-row-transaction-information"
  >
    <div class="transaction-text">
      {{
        browserDimensions?.isPortrait && isTouch && vm?.hasSecondaryTransaction
          ? vm?.transactionTypeStringShort
          : vm?.transactionTypeString
      }}
      <a
        [class.plain-text]="!vm?.isr"
        (click)="!!vm?.isr && onViewInvoiceClick()"
        href="javascript:void(0)"
      >
        #{{
          vm?.hasSecondaryTransaction
            ? vm?.secondaryTransactionNumber
            : vm?.transactionNumber
        }}
      </a>
      <div
        *ngIf="vm?.hasSecondaryTransaction"
        [class.second-transaction]="isReview"
      >
        {{ translatorText.invoice }} #{{ vm?.transactionNumber }}
      </div>
    </div>
  </ion-col>
  <ion-col
    [size]="columnSizes['transaction-row-po-number']"
    data-cy="transaction-row-po-number"
    class="po-number-column"
  >
    <div
      [class.clickable]="isPoClickable"
      class="customer-po-content"
      (click)="onCustomerPOClick()"
    >
      <p>
        {{ vm?.customerPO ? truncatedPO : 'N/A' }}
      </p>
      <ion-icon
        src="assets/icon/chevron-right-outline-green.svg"
        [class]="showFullPO ? 'expanded' : 'normal'"
        *ngIf="isPoClickable"
      ></ion-icon>
    </div>
  </ion-col>
  <ion-col
    *ngIf="showOrderNumber"
    [size]="columnSizes['transaction-row-order-number']"
    class="order-number-column"
    data-cy="transaction-row-order-number"
  >
    {{ vm?.orderNumber || 'N/A' }}
  </ion-col>
  <ion-col
    [size]="columnSizes['transaction-row-issue-date']"
    data-cy="transaction-row-issue-date"
  >
    {{ vm?.issueDate | date: 'M/d/yyyy' : 'GMT' }}
  </ion-col>
  <ion-col
    [size]="columnSizes['transaction-row-amount']"
    data-cy="transaction-row-amount"
  >
    {{ vm?.amount | currency }}
  </ion-col>
  <ion-col
    [size]="columnSizes['transaction-row-amount-due']"
    class="amount-due-column"
    data-cy="transaction-row-amount-due"
  >
    {{ vm?.amountDue | currency }}
  </ion-col>
  <ion-col
    [size]="columnSizes['transaction-row-due-date']"
    data-cy="transaction-row-due-date"
  >
    {{ vm?.dueDate | date: 'M/d/yyyy' : 'GMT' }}
  </ion-col>

  <ion-col
    *ngIf="isReview"
    [size]="columnSizes['transaction-row-payment-amount']"
    class="payment-amount"
    data-cy="transaction-row-payment-amount"
  >
    {{ vm?.paymentAmount | currency }}
  </ion-col>

  <ng-container *ngIf="!isReview">
    <ion-col
      [size]="columnSizes['transaction-row-status']"
      data-cy="transaction-row-status"
    >
      <span
        class="transaction-status-circle"
        [ngClass]="{
          yellow: vm?.status === Status.UNPAID,
          red:
            vm?.status === Status.OVERDUE ||
            vm?.status === Status.PARTIALLY_PAID ||
            vm?.status === Status.CANCELLING,
        }"
      ></span>
      <span>{{ vm?.statusString }}</span>
    </ion-col>
    <ion-col
      *ngIf="!shouldHaveEditableAmount"
      [size]="columnSizes['transaction-row-pay-button']"
    >
      <a
        *ngIf="showPayButton"
        class="green-link"
        (click)="onPayTransactionClick()"
        href="javascript:void(0)"
      >
        {{ translatorText.pay }}
      </a>
    </ion-col>
  </ng-container>

  <ion-col *ngIf="shouldShowButtons" class="ion-align-self-end">
    <div class="buttons-column" *ngIf="showButtons">
      <ion-icon
        color="success"
        name="ellipsis-vertical"
        data-cy="transaction-row-more-options-desktop-tablet-btn"
        (click)="onMoreOptionClick($event)"
      >
      </ion-icon>
    </div>
  </ion-col>

  <ion-col
    *ngIf="shouldHaveEditableAmount"
    class="edit-amount"
    [size]="columnSizes['transaction-row-edit-amount']"
  >
    <app-edit-payment-amount-input
      [disabled]="!showEditAmount"
      [maxVal]="vm.amountDue"
      [paymentAmount]="vm.paymentAmount"
      (updatePaymentAmountEmitter)="updatePaymentAmount($event)"
    ></app-edit-payment-amount-input>
  </ion-col>
</ion-row>
